import { Box, Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

function statusColor(status) {
  switch ((status || "").toLowerCase()) {
    case "new": return "#2196f3";
    case "open": return "#4caf50";  
    case "in progress": return "#a2a2a2"; 
    case "review": return "#ff9800"; 
    case "closed": return "#f44336"; 
    default: return "#c0c0c0";
  }
}

export function StatusChip({ status }) {
  return (
    <Box sx={{ display: "inline-flex", alignItems: "center" }}>
      <Box
        sx={{
          width: 12,
          height: 12,
          borderRadius: "50%",
          backgroundColor: statusColor(status),
          mr: 1,
        }}
      />
      <Typography component="span" sx={{ fontWeight: 600, textTransform: "capitalize" }}>
        {status}
      </Typography>
    </Box>
  );
}

StatusChip.propTypes = {
  status: PropTypes.string,
};
